import axios from 'axios';
import env from './env';
axios.defaults.withCredentials = true;
const instance = axios.create({
  baseURL: env.apiURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

instance.interceptors.response.use(
  response => response.data,
  error =>
    error.response
      ? Promise.reject(error.response.data)
      : Promise.reject(error),
);

export default instance;
